import React from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  maxLength,
  required,
  useNotify,
  useRedirect,
} from "react-admin";

import { CachedProvincesInput } from '../common/CachedProvincesInput/CachedProvincesInput';

export const TechnicalServiceCreate = (props) => {
  const notify = useNotify();
  const redirect = useRedirect();

  const onSuccess = (data) => {
    notify("Servicio técnico creado exitosamente", {
      type: "info",
      messageArgs: { smart_count: 1, name: data.name },
    });
    redirect("list", props.basePath || "/services", data.id, data);
  };

  return (
    <Create
      {...props}
      mutationOptions={{ onSuccess }}
      transform={(data) => ({
        ...data,
        province: { id: data.provinceId },
      })}
    >
      <SimpleForm>
        <TextInput
          source="name"
          label="Nombre"
          validate={[required(), maxLength(100)]}
        />
        <CachedProvincesInput
          source="provinceId"
          label="Provincia"
          validate={[required()]}
        />
        <TextInput
          source="city"
          label="Ciudad"
          validate={[required(), maxLength(100)]}
        />
        <TextInput
          source="address"
          label="Dirección"
          validate={[required(), maxLength(100)]}
        />
        <TextInput
          source="phone"
          label="Teléfono"
          validate={[required(), maxLength(100)]}
        />
      </SimpleForm>
    </Create>
  );
};
